<template>
	<Page>
		<div class="centered">
			<Breadcrumb :crumbs="[
				{
					text : 'Home',
					to : {name:'templates'},
				},
				{
					text : 'Saved Configs',
					to : {name:'configs'},
				},
				{
					text : config.name,
					to : {name:'config',params:{config_id:config.id}},
				},
			]" />

			<div class="TopWithActions">
				<div class="main">
					<div class="TemplateName">
						<input type="text" v-model="name" placeholder="Enter a name" />
					</div>

				</div>
				<div class="actions">
					<button :class="{'btn-a':1,'_btn_submitting':saving}" :disabled="!changed" @click="saveConfig" >Save changes</button>
					<button :class="{'btn-warning':1,'_btn_submitting':deleting}" @click="deleteConfig" ><i class="fa fa-trash-alt"></i></button>
				</div>
			</div>

			<!-- <ConfigNav :config="config" /> -->

		
			<TemplateInput
				class="nomaxheight"
				:key="config.id"
				v-model="code"
				/>
				
		</div>
	</Page>
</template>

<script>

	import Page from '../mixins/Page';
	// import ConfigNav from '../components/ConfigNav'
	import Breadcrumb from '../components/Breadcrumb';
	import TemplateInput from "../components/TemplateInput.vue";
	import Hashr from '../utils/Hashr';

	var loaded_config = null;

	export default {
		mixins : [Page],

		components : {
			// ConfigNav,
			Breadcrumb,
			TemplateInput,
		},

		data(){
			return {
				deleting : false,
				saving : false,
				config : loaded_config,
				name : loaded_config.name,
				code : {body:loaded_config.config},
				last_saved_hash : this.calculateSaveHash(loaded_config),
			}
		},


		computed:{
			changed(){
				return this.calculateSaveHash({name:this.name,config:this.code.body}) != this.last_saved_hash;
			},
		},

		beforeRouteEnter(to, from, next){
			api.get('config',to.params.config_id)
				.then((config)=>{
					loaded_config = config;
					next();
				});
		},

		methods:{
			calculateSaveHash(config){
				return Hashr(JSON.stringify({name:config.name,config:config.config}));
			},
			saveConfig(){
				var self = this;

				var payload = {
					name : self.name,
					config : self.code.body
				}
				self.saving = true;

				return api.update('config',self.config.id,payload).then(function(config){
					self.last_saved_hash = self.calculateSaveHash(config);
				}).catch(function(e){
					alert(e.message || 'Failed to save config. Try again.');
				}).then(function(){
					self.saving = false;
				});
			},
			deleteConfig(){
				var self = this;

				if(!confirm('Are you sure you want to permanently delete this generated config?')) return false;

				self.deleting = true;

				return api.delete('config',self.config.id).then(function(config){
					self.$router.push({name:'configs'});
				}).catch(function(e){
					alert(e.message || 'Failed to delete config. Try again.');
				}).then(function(){
					self.deleting = false;
				});
			},
		}

	}

</script>